"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var PlaybackPlayButton = function PlaybackPlayButton(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M12.003 19.506a7.5 7.5 0 110-15 7.5 7.5 0 010 15zm3.708-8.062l-5.62-2.815a.625.625 0 00-.904.56v5.63a.625.625 0 00.904.56l5.62-2.816a.627.627 0 000-1.12z"
  }));
};

var _default = (0, _react.forwardRef)(PlaybackPlayButton);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(PlaybackPlayButton, "PlaybackPlayButton", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/PlaybackPlayButton.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/PlaybackPlayButton.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JY29ucy9QbGF5YmFja1BsYXlCdXR0b24udHN4Il0sIm5hbWVzIjpbIlBsYXliYWNrUGxheUJ1dHRvbiIsInByb3BzIiwicmVmIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O0FBQUE7Ozs7Ozs7Ozs7Ozs7QUFFQSxJQUFNQSxrQkFBa0YsR0FBRyxTQUFyRkEsa0JBQXFGLENBQUNDLEtBQUQsRUFBUUMsR0FBUjtBQUFBLFNBQ3pGO0FBQUssSUFBQSxLQUFLLEVBQUUsRUFBWjtBQUFnQixJQUFBLE1BQU0sRUFBRSxFQUF4QjtBQUE0QixJQUFBLE9BQU8sRUFBQztBQUFwQyxLQUFvREQsS0FBcEQ7QUFBMkQsSUFBQSxHQUFHLEVBQUVDO0FBQWhFLE1BQ0U7QUFDRSxJQUFBLElBQUksRUFBQyxjQURQO0FBRUUsSUFBQSxDQUFDLEVBQUM7QUFGSixJQURGLENBRHlGO0FBQUEsQ0FBM0Y7O2VBU2UsdUJBQVdGLGtCQUFYLEM7Ozs7Ozs7Ozs7Ozs7MEJBVFRBLGtCIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IGZvcndhcmRSZWYsIFJlZkZvcndhcmRpbmdDb21wb25lbnQsIFNWR1Byb3BzIH0gZnJvbSAncmVhY3QnO1xuXG5jb25zdCBQbGF5YmFja1BsYXlCdXR0b246IFJlZkZvcndhcmRpbmdDb21wb25lbnQ8U1ZHU1ZHRWxlbWVudCwgU1ZHUHJvcHM8U1ZHU1ZHRWxlbWVudD4+ID0gKHByb3BzLCByZWYpID0+IChcbiAgPHN2ZyB3aWR0aD17MjR9IGhlaWdodD17MjR9IHZpZXdCb3g9XCIwIDAgMjQgMjRcIiB7Li4ucHJvcHN9IHJlZj17cmVmfT5cbiAgICA8cGF0aFxuICAgICAgZmlsbD1cImN1cnJlbnRDb2xvclwiXG4gICAgICBkPVwiTTEyLjAwMyAxOS41MDZhNy41IDcuNSAwIDExMC0xNSA3LjUgNy41IDAgMDEwIDE1em0zLjcwOC04LjA2MmwtNS42Mi0yLjgxNWEuNjI1LjYyNSAwIDAwLS45MDQuNTZ2NS42M2EuNjI1LjYyNSAwIDAwLjkwNC41Nmw1LjYyLTIuODE2YS42MjcuNjI3IDAgMDAwLTEuMTJ6XCJcbiAgICAvPlxuICA8L3N2Zz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IGZvcndhcmRSZWYoUGxheWJhY2tQbGF5QnV0dG9uKTtcbiJdfQ==